import { Button } from 'react-bootstrap';

type IncidentsPagerProps = {
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
};

export function lastPage(pageSize: number, totalCount: number): number {
  return Math.max(1, Math.ceil(totalCount / pageSize));
}

export function pageIndicator(page: number, pageSize: number, totalCount: number): string {
  const noun = totalCount === 1 ? 'incident' : 'incidents';

  return `Page ${page} of ${lastPage(pageSize, totalCount)} · ${totalCount} ${noun}`;
}

function IncidentsPager({ page, pageSize, totalCount, onPageChange }: IncidentsPagerProps) {
  return (
    <nav aria-label="Incident pages" className="diagnostics-pager">
      <span role="status" className="diagnostics-pager-indicator">
        {pageIndicator(page, pageSize, totalCount)}
      </span>
      <Button variant="outline-secondary" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        Previous page
      </Button>
      <Button
        variant="outline-secondary"
        size="sm"
        disabled={page >= lastPage(pageSize, totalCount)}
        onClick={() => onPageChange(page + 1)}
      >
        Next page
      </Button>
    </nav>
  );
}

export default IncidentsPager;
